import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {}

export const affiliateCompanySlice = createSlice({
  name: 'affiliate_company',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    initializeAffiliateCompany: () => initialState,
    setAffiliateCompany: (state, action) => {
      state = { ...state, ...action.payload }
      return state
    }
  }
})

export const { initializeAffiliateCompany, setAffiliateCompany } = affiliateCompanySlice.actions

export default affiliateCompanySlice.reducer
